import { createSelector } from 'reselect';

const storeSeminars = (store, props) => store.seminarData.seminars;
const storeSeminarDataIds = (store, props) => store.seminarData.dataIds;

export const getSeminars = createSelector(
  storeSeminars,
  storeSeminarDataIds,
  (seminars, ids) => {
    return (
      seminars &&
      ids &&
      ids.length > 0 &&
      ids.map(id => {
        let seminatObj = seminars[id];
        seminatObj['seminar_id'] = id;
        return seminatObj;
      })
    );
  }
);



// WEBPACK FOOTER //
// ./src/selectors/seminars.js